
const digest = '0b660f14bfd07ae89a227d03829bafe1d8b375ccdee148bbfd387ef0d8f32c90';
const classes = {"wrapper":"_wrapper_1wn3g_1","buttons":"_buttons_1wn3g_6"};
const css = `._wrapper_1wn3g_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_1wn3g_1 ._buttons_1wn3g_6 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  